module.exports = __webpack_public_path__ + "static/media/group-expanded.e8a1fa90.svg";